import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faCheck,
  faComments,
  faLaptopMedical,
  faListCheck,
} from '@fortawesome/free-solid-svg-icons';
import logoImage from '../../img/logo.png';
import '../../styles/DemonstrationPage.css';

const DemonstrationThankYouPage = () => {
  const location = useLocation();
  const firstName = location.state?.firstName;

  return (
    <div className="demonstration-page demonstration-page--thank-you">
      <header className="demonstration-page__header">
        <Link to="/inicio" aria-label="Voltar para a página inicial">
          <img src={logoImage} alt="Fluxo Clínica" className="demonstration-page__logo" />
        </Link>
      </header>

      <main className="demonstration-thanks">
        <div className="demonstration-thanks__icon">
          <FontAwesomeIcon icon={faCheck} />
        </div>
        <span className="demonstration-page__eyebrow">Solicitação recebida</span>
        <h1>{firstName ? `${firstName}, vamos conversar!` : 'Vamos conversar!'}</h1>
        <p>
          Recebemos as informações. O próximo passo é entender sua rotina e mostrar
          como o Fluxo Clínica pode ajudar sua operação.
        </p>

        <div className="demonstration-thanks__steps">
          <div>
            <span><FontAwesomeIcon icon={faComments} /></span>
            <strong>1. Primeiro contato</strong>
            <p>Entraremos em contato usando os dados informados.</p>
          </div>
          <div>
            <span><FontAwesomeIcon icon={faListCheck} /></span>
            <strong>2. Entendimento</strong>
            <p>Vamos conhecer a estrutura e as prioridades da clínica.</p>
          </div>
          <div>
            <span><FontAwesomeIcon icon={faLaptopMedical} /></span>
            <strong>3. Demonstração</strong>
            <p>Você verá os módulos mais importantes para sua realidade.</p>
          </div>
        </div>

        <Link to="/inicio" className="demonstration-page__submit demonstration-thanks__button">
          Voltar para o site
          <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </main>
    </div>
  );
};

export default DemonstrationThankYouPage;
